<template>
	<div class="home">
		<header>
			<img src="../assets/img/logo.gif" alt="" />
			<!-- <img src="../assets/img/code.gif" alt="" /> -->
			<img class="code-img" src="../assets/img/code.jpg" alt="" />
		</header>
		<!-- 导航栏 -->
		<div class="nav1" :class="top ? 'nav-fixed' : ''">
			<ul class="nav1-ul">
				<li v-for="n in navList" :key="n.code" @mouseover="n.show = true" @mouseleave="n.show = false">
					<div @click="n.url ? goDetail(n.url, n.vipFlag, n.code) : ''">{{ n.name }}</div>
					<ul v-show="n.show && n?.children.length" class="n">
						<li v-for="c in n.children" :key="c.code">
							<div @click="goDetail(c.url, c.vipFlag, n.code, c.code)">{{ c.name }}</div>
						</li>
					</ul>
				</li>
			</ul>
		</div>
		<div class="banner">
			<img src="../assets/img/f177031f195294324b24f374ccd68927.jpeg" alt="" />
			<div>
				<p>提供服务·反应诉求·规范行为·引领发展</p>
				<p class="en">Providing Services, Reflecting Demands, Regulating Behavior, Leading Development</p>
			</div>
		</div>
		<router-view></router-view>
		<div class="top" @click="toTop" v-if="top">
			<i class="iconfont icon-zhiding"></i>
		</div>
		<UserLogin></UserLogin>
		<Register></Register>
		<TrainingService></TrainingService>
		<HouseCampaign></HouseCampaign>
		<div class="layout-footer">
			<div class="layout-footer-content"><span class="company-info-text">版权所有：上海房地产行业协会</span><span class="company-info-text">技术支持：上海南康科技有限公司</span></div>
			<div class="layout-footer-content">
				<span class="layout-footer-item-text" @click="handleJump(1)">沪ICP备2022004688号-1</span>
				<span class="layout-footer-item-text" @click="handleJump(2)"> <img src="../assets/img/footer-logo.png" alt="" />沪公网安备31010502007280号</span>
			</div>
		</div>
		<el-dialog :visible.sync="isShowXFCS" width="450px" @close="handleClose">
			<i class="iconfont icon-guanbi" @click="handleClose()"></i>
			<div class="title">
				<img src="../assets/img/图片1.png" alt="" />
				<h3>自律平台 <span>•</span> 新房超市</h3>
			</div>
			<div class="dialog-content">建设中...</div>
		</el-dialog>
	</div>
</template>

<script>
import UserLogin from './UserLogin.vue';
import Register from './Register.vue';
import TrainingService from './TrainingService.vue';
import HouseCampaign from './HouseCampaign.vue';

import { NavApi } from '../axios/request';
export default {
	components: { UserLogin, Register, TrainingService, HouseCampaign },
	// eslint-disable-next-line vue/multi-word-component-names
	name: 'Home',
	data() {
		return {
			isShowXFCS: false,
			navList: [],
			top: false,
		};
	},
	mounted() {
		this.$router.afterEach(() => {
			window, scrollTo(0, 0);
		});
		window.addEventListener('scroll', this.handleScroll);
		this.getData();
	},
	methods: {
		// 获得一级菜单数据
		async getData() {
			const res = await NavApi({ level: 1 });
			// console.log('一级菜单', res);
			if (res != null && res.code == 200) {
				let d = res.data;
				for (const i in d) {
					if (d[i].code == 'WEB_INDEX') {
						d[i].url = 'homeContent';
					}
					d[i].show = false;
					d[i].children = [];
				}
				// const newMenuItem = {
				// 	code: 'WEB_XFCS',
				// 	icon: null,
				// 	id: 999,
				// 	indexImg: null,
				// 	level: 1,
				// 	menu: 0,
				// 	menuValue: '否',
				// 	name: '新房超市',
				// 	pcode: 'ROOT',
				// 	show: false,
				// 	sort: 7,
				// 	status: 1,
				// 	statusValue: '有效',
				// 	type: 3,
				// 	typeValue: '网站页面',
				// 	url: 'homeContent',
				// 	vipFlag: null,
				// 	children: [],
				// };

				// d.push(newMenuItem);

				this.navList = d;
				this.getData2();
			}
		},
		// 获得二级菜单数据
		async getData2() {
			const res = await NavApi({ level: 2 });
			// console.log('二级菜单', res)
			if (res != null && res.code == 200) {
				let d = res.data;
				for (const i in d) {
					for (const j in this.navList) {
						if (d[i].pcode == this.navList[j].code) {
							this.navList[j].children.push(d[i]);
						}
					}
				}
				this.$store.state.nav = this.navList;
			}
		}, // 关闭弹窗
		handleClose() {
			this.isShowXFCS = false;
		},
		// 跳转文章列表页
		goDetail(url, vipFlag, code, childrenCode) {
			const token = this.$store.state.token;
			if ((code == 'WEB_HYFW' && childrenCode !== 'WEB_HYFW_PXFW') || (code == 'WEB_GXDJ' && childrenCode == 'WEB_GXDJ_SQ')) {
				if (!token) {
					this.login();
					return;
				}
			}
			if (code == 'WEB_GXDJ' && childrenCode == 'WEB_GXDJ-czgy') {
				const openUrl = 'http://www.dataln.com/sreta/#/'; //长租公寓
				window.open(openUrl);
				return;
			}
			if (url && url.startsWith('http')) {
				window.open(url);
				return;
			}
			switch (code) {
				// case 'WEB_XFCS':
				// 	console.log(url, vipFlag, code, childrenCode);
				// 	this.isShowXFCS = true;
				// 	break;
				case 'WEB_INDEX':
					if (childrenCode == undefined) {
						this.$router.push({ name: 'homeContent' });
					} else {
						const titles = {
							'SY-PINGPAIFANGQI': '品牌房企',
							'SY-YZGYS': '优秀供应商',
						};
						if (titles[childrenCode]) {
							this.$router.push({
								name: 'brandContent',
								query: { typea: code, typeb: childrenCode, title: titles[childrenCode] },
							});
						} else {
							this.$router.push({
								name: 'articleList',
								query: { typea: code, typeb: childrenCode },
							});
						}
					}
					break;
				case 'WEB_GXDJ':
					if (['WEB_GXDJ_KPFW'].includes(childrenCode)) {
						// 房地产交易代办服务全流程 && 开盘服务
						this.$router.push({
							name: 'bcPdf',
							query: { typea: code, typeb: childrenCode, id: 1 },
						});
					} else if (childrenCode == 'WEB_GXDJ-jydb') {
						//房地产交易代办服务全流程
						// var fdjyUrl = '';
						// if (process.env.NODE_ENV === 'development') {
						// 	fdjyUrl = 'http://localhost:8080/#/main/index'; // 本机地址（开发环境）
						// } else if (process.env.NODE_ENV === 'production') {
						// 	fdjyUrl = 'http://47.116.163.170:8081/#/main/index'; // 正式环境地址（生产环境）
						// }
						// window.open(fdjyUrl);
						const fullUrl = this.$router.resolve({ name: 'index' }).href;
						window.open(fullUrl, '_blank');
					} else if (childrenCode == 'WEB_GXDJ_SQ') {
						//供需对接申请
						const title = '供需对接申请';
						const url = `${process.env.VUE_APP_BASE_URL_API}/nkyxf/nav/gxdj-t/form?title=${title}&token=${token}`;
						window.location.href = url;
						// } else if (childrenCode == 'WEB_GXDJ-czgy') {
						// 	window.open('http://www.dataln.com/sreta/#/');
					} else if (childrenCode == 'WEB_GXDJ_XYPX') {
						//f房地产专修学院培训
						window.open('http://www.fdcxy.org/');
					} else {
						this.$router.push({
							name: 'articleList',
							query: { typea: code, typeb: childrenCode },
						});
					}
					break;
				default:
					this.$router.push({
						name: 'articleList',
						query: { typea: code, typeb: childrenCode },
					});
					break;
			}
		},

		// 获取页面滚动距离
		handleScroll() {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 200) {
				this.top = true;
			} else {
				this.top = false;
			}
		},
		//回到顶部
		toTop() {
			let Top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// 设置计时器，实现滚动效果
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = Top -= 50;
				if (Top <= 10) {
					clearInterval(timeTop);
				}
			}, 20);
		},
		// 底部跳转
		handleJump(code) {
			if (code == 1) {
				window.open('https://beian.miit.gov.cn/');
			} else if (code == 2) {
				window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502007280');
			}
		},
		login() {
			this.$store.commit('getLogin', true);
		},
	},
};
</script>

<style scoped>
.home {
	width: 100%;
	height: 100%;
	/* padding-bottom: 4rem; */
	overflow: hidden;
}
header,
.nav1-ul {
	width: var(--main--width);
}
.code-img {
	width: 100px;
	/* height: 100px; */
}
header {
	margin: 0.625rem auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.nav1 {
	width: 100%;
	min-width: var(--main--width);
	background-color: var(--bg-color);
}

.nav-fixed {
	position: fixed;
	top: 0;
	z-index: 999;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.nav1-ul {
	margin: 0 auto;
	display: flex;
	align-items: center;
}

.nav1-ul li {
	position: relative;
	width: 130px;
	text-align: center;
	font-size: 16px;
	color: #fff;
	cursor: pointer;
}

.nav1-ul div {
	padding: 15px 5px;
	width: 100%;
	height: 100%;
}

.nav1-ul div:hover {
	color: var(--text-light-color);
}

.nav1-ul ul {
	position: absolute;
	top: 100%;
	left: 0;
	background-color: var(--bg-color);
	z-index: 11;
}

.nav1-ul a {
	color: #fff;
}

.banner {
	position: relative;
}

.banner img {
	width: 100%;
	min-width: var(--main--width);
	height: 350px;
	object-fit: fill;
}

.banner div {
	position: absolute;
	top: 50px;
	left: 20%;
	font-size: 47px;
	color: #fff;
	white-space: nowrap;
	letter-spacing: 4px;
	font-weight: 300;
}

.banner div .en {
	margin-top: 8px;
	margin-left: 6px;
	font-size: 12px;
	letter-spacing: 1px;
}

.top {
	position: fixed;
	width: 40px;
	height: 40px;
	line-height: 40px;
	bottom: 50px;
	right: 20px;
	text-align: center;
	background-color: #aeaeae;
	border-radius: 20px;
	cursor: pointer;
	z-index: 2;
}

.top:hover {
	background-color: var(--bg-color);
}

.top .iconfont {
	color: #fff;
	font-size: 23px;
}
:deep(.el-dialog) {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0 !important;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 10px;
}

:deep(.el-dialog__header) {
	display: none;
}

:deep(.el-dialog__body) {
	padding: 20px 0 !important;
	width: 74%;
	color: var(--text-color2);
}

.icon-guanbi {
	position: absolute;
	top: 20px;
	right: 20px;
	font-size: 25px;
	color: #adadad;
	cursor: pointer;
}

.icon-guanbi:hover {
	color: #666;
}
.dialog-content {
	width: 100%;
	font-size: 18px;
	line-height: 100px;
	text-align: center;
	margin: 0 auto;
	height: 150px;
}

.title {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 24px auto;
}

.title img {
	margin-right: 15px;
	width: 45px;
	height: 45px;
}

.title h3 {
	font-size: 1.4375rem;
}

.title span {
	color: #666;
}

:deep(.el-input__inner:focus) {
	border-color: var(--bg-color);
}

.validateCodeImg {
	cursor: pointer;
}

.el-button {
	width: 100%;
	background-color: var(--bg-color);
	border-color: var(--bg-color);
	color: #fff;
}

.el-button:hover {
	background-color: var(--bg-color-8);
	border: 1px solid var(--bg-color-8);
	color: var(--text-light-color);
}

.layout-footer {
	width: 100%;
	background-color: var(--bg-color);
	height: 15rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.layout-footer-content {
	width: var(--main--width);
	display: flex;
	padding: 10px 0;
	justify-content: center;
	align-items: center;
	flex-direction: row;
}
.layout-footer-content .layout-footer-item-text {
	padding: 0 10px;
	font-size: 16px;
	color: #fff;
	height: 25px;
	line-height: 30px;
	cursor: pointer;
	display: flex; /* 添加 flex 布局 */
	align-items: center; /* 垂直居中 */
	justify-content: center;
}
.layout-footer-content .layout-footer-item-text img {
	margin: 0 5px 0 0;
	width: 18px;
	height: 18px;
}
.layout-footer-item-text:first-child::after {
	content: '';
	display: inline-block;
	width: 1px;
	height: 20px; /* 竖线的高度 */
	background-color: #fff; /* 竖线的颜色 */
	margin-left: 20px;
	vertical-align: middle;
}
.company-info-text {
	font-size: 17px;
	padding: 0 10px;
	color: #fff;
}
.company-info-text {
	font-size: 17px;
	padding: 0 10px;
	color: #fff;
}
</style>
